import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { EndpointService, Logger } from '@app/core';
import { EtapasDetalleTramite, EtapasDetalleTramiteApi, TramiteBasico, ActividadDeault, Tarea } from '@app/shared';

const log = new Logger('StageDetailViewComponent');
@Injectable()
export class StageDetailViewDataService {

  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) { }


  /**
   * Carga los datos de ver informacion tramite etapa
   *
   * @param {number} id
   * @return {*}  {Observable<EtapasDetalleTramite[]>}
   * @memberof StageDetailViewDataService
   */
  getStageDetailView(id: number): Observable<EtapasDetalleTramite[]> {

    return this.http.get<EtapasDetalleTramite[]>(this.api.get('adminStagesRange', [id]));
  }

  /**
   * actualiza informacion adicional a la etapa
   *
   * @param {number} id
   * @param {*} stageDetailView
   * @return {*}  {Promise<boolean>}
   * @memberof StageDetailViewDataService
   */
  updateStageDetailView(id: number, stageDetailView: EtapasDetalleTramiteApi): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().put<boolean>(this.api.get('adminStagesRange', [id]), stageDetailView).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Informacion de la etapa modificada correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }


  /**
   * Agrega informacion adicional a la etapa
   *
   * @param {*} stageDetailView
   * @return {*}  {Promise<boolean>}
   * @memberof StageDetailViewDataService
   */
  addStageDetailView(stageDetailView: EtapasDetalleTramiteApi): Promise<boolean> {
    return new Promise((resolve, reject) => {
      log.debug('Envía: ' + this.api.get('adminStagesRange'), stageDetailView);
      this.http.skipErrorHandler().post<boolean>(this.api.get('adminStagesRange'), stageDetailView).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Informacion de la etapa agregada correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }

  /**
   * Elimina informacion adicional de la etapa
   *
   * @param {number} id
   * @return {*}  {Promise<boolean>}
   * @memberof StageDetailViewDataService
   */
  deleteStageDetailView(id: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler().delete<boolean>(this.api.get('adminStagesRange', [id])).subscribe(
        resp => {
          this.toastr.success('Operación exitosa', 'Informacion de la etapa eliminada correctamente');
          resolve(true);
        },
        err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error('Fallo del sistema', 'Error de operacion');
          }
          reject(err);
        }
      );
    });
  }


  /**
   * Consulta un tramite por default.
   *
   * @param {number} idTramite
   * @return {*}  {Promise<TramiteBasico>}
   * @memberof StageDetailViewDataService
   */
  getDefaultTramite(idTramite: number): Promise<TramiteBasico> {
    return new Promise((resolve, reject) => {
      this.http.get<TramiteBasico>(this.api.get('tramiteTasks', [idTramite])).subscribe(
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  }


  /**
     * Carga una actividad especifica
     *
     * @param {number} id
     * @return {*}  {Observable<EtapasDetalleTramite[]>}
     * @memberof StageDetailViewDataService
     */
  getActivity(id: number): Promise<ActividadDeault> {

    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
        .get<ActividadDeault>(this.api.get('defaultActivity', [id]))
        .subscribe(
          activity => {
            resolve(activity);
          },
          err => {
            reject(null);
            log.debug(err);
          }
        );
    });
  }

  
  /**
   * Consulta una tarea predeterminada en especifico con el id de la tarea
   *
   * @param {number} idTask
   * @return {*}  {Promise<Tarea>}
   * @memberof StageDetailViewDataService
   */
  getTask(idTask: number): Promise<Tarea> {
    return new Promise((resolve, reject) => {
      this.http.skipErrorHandler()
        .get<Tarea>(this.api.get('defaultTask', [idTask]))
        .subscribe(
          task => {
            resolve(task);
          },
          err => {
            reject(null);
            log.debug(err);
          }
        );
    });
  }

}






// WEBPACK FOOTER //
// ./src/app/administration/management-automation/time-control/tramit-stages/stage-detail-view/shared/stage-detail-view.data.service.ts